import React from 'react';
import { RichText, ValRichText, ValImage } from '@valbuild/next';

export interface BodyProps {
  richText?: RichText<{
    h1: true;
    h2: true;
    h3: true;
    h4: true;
    h5: true;
    h6: true;
    ul: true;
    ol: true;
    a: true;
    img: true;
    bold: true;
    italic: true;
    lineThrough: true;
  }>;
  className?: string;
  size?: 'small' | 'medium' | 'large' | 'extraLarge';
  children?: React.ReactNode | React.ReactNode[];
}

const Body: React.FC<BodyProps> = ({ richText, children, className, size }) => {
  let classes = '';
  switch (size) {
    case 'small':
      classes = 'text-base leading-blank-looser';
      break;
    case 'medium':
      classes = 'text-lg leading-blank-relaxed';
      break;
    case 'large':
      classes = 'text-xl leading-blank-loose';
      break;
    case 'extraLarge':
      classes =
        'laptop:text-plakat-smaller tablet:text-plakat-smallest text-xl leading-blank-loose';
      break;
    default:
      classes =
        'text-base leading-blank-looser tablet:text-lg tablet:leading-blank-relaxed laptop:text-xl laptop:leading-blank-loose';
  }

  const cn = `font-sans break-words transition-50ms ${className} ${
    !className && classes
  }`;

  if (richText) {
    return (
      <div className={cn}>
        <ValRichText
          theme={{
            bold: 'font-bold',
            a: 'underline decoration-1 underline-offset-4 no-line-hover-line',
            italic: 'italic',
            lineThrough: 'line-through',
            ol: 'mb-8 tablet:mb-24 last:mb-0 list-decimal space-y-12 pl-24',
            ul: 'mb-8 tablet:mb-24 last:mb-0 list-[square] space-y-12 pl-24',
            h1: 'mt-64 first:mt-0 mb-8 last:mb-0 text-pretty',
            h2: 'mt-64 first:mt-0 mb-8 last:mb-0 text-pretty',
            h3: 'mt-64 first:mt-0 mb-8 last:mb-0 text-2xl tablet:text-3xl text-pretty',
            h4: 'mt-64 first:mt-0 mb-8 last:mb-0 text-xl tablet:text-2xl text-pretty',
            h5: 'mt-64 first:mt-0 mb-8 last:mb-0 text-lg tablet:text-xl text-pretty',
            h6: 'mt-64 first:mt-0 mb-8 last:mb-0 text-pretty',
            img: null,
            li: 'pl-8 text-pretty',
            p: 'mb-24 tablet:mb-32 last:mb-0 text-pretty',
          }}
          transform={(node) => {
            if (typeof node !== 'string' && node.tag === 'img') {
              return (
                <ValImage className="mt-24 laptop:w-[720px]" src={node.src} />
              );
            }
          }}
        >
          {richText}
        </ValRichText>
      </div>
    );
  }

  return <p className={cn}>{children}</p>;
};

export default Body;
